import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Reveal, Overline } from "../components/Reveal";
import BeforeAfterSlider from "../components/BeforeAfterSlider";
import { ArrowUpRight } from "lucide-react";

const DEMO = [{
  id: "demo", title: "Master Bathroom", location: "Richmond, VA",
  before_image: "https://images.pexels.com/photos/6587852/pexels-photo-6587852.jpeg",
  after_image: "https://images.pexels.com/photos/8142047/pexels-photo-8142047.jpeg",
}];

export default function WorkPage() {
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  const list = projects.length ? projects : DEMO;
  const p = list[active] || list[0];

  return (
    <div>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-36 md:pt-44 pb-16">
        <Reveal>
          <Overline>Our Projects</Overline>
          <h1 className="mt-6 font-serif font-light text-5xl md:text-7xl leading-[0.95] max-w-4xl">Before &amp; <em className="gold-gradient-text">After.</em></h1>
          <p className="mt-8 max-w-2xl text-white/60 font-body text-lg leading-relaxed">Real transformations from homes across Virginia. Drag the handle to reveal the difference.</p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-20">
        <Reveal>
          <BeforeAfterSlider key={p.id} before={p.before_image} after={p.after_image} beforeLabel="BEFORE" afterLabel="AFTER" />
          <div className="mt-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <p className="font-serif text-2xl">{p.title}</p>
              {p.location && <p className="text-white/50 text-sm font-body">{p.location}</p>}
            </div>
            {list.length > 1 && (
              <div className="flex flex-wrap gap-2">
                {list.map((item, i) => (
                  <button key={item.id} data-testid={`work-thumb-${i}`} onClick={() => setActive(i)} className={`h-14 w-20 overflow-hidden border transition-all ${i === active ? "border-gold" : "border-white/10 opacity-50 hover:opacity-100"}`}>
                    <img src={item.after_image} alt={item.title} className="h-full w-full object-cover" />
                  </button>
                ))}
              </div>
            )}
          </div>
        </Reveal>
      </section>

      {projects.length > 0 && (
        <section className="border-t border-white/10 bg-[#080808] py-24">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10">
            <Reveal><Overline>Portfolio</Overline><h2 className="mt-6 font-serif font-light text-4xl md:text-5xl">Recent work</h2></Reveal>
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {projects.map((pr, i) => (
                <Reveal key={pr.id} delay={(i % 3) * 0.08}>
                  <div data-testid={`gallery-item-${pr.id}`} className="group relative overflow-hidden aspect-[4/5] border border-white/10">
                    <img src={pr.after_image} alt={pr.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
                    <div className="absolute bottom-0 left-0 p-6">
                      <p className="text-xs uppercase tracking-widest text-gold">{pr.category}</p>
                      <p className="font-serif text-2xl mt-1">{pr.title}</p>
                      {pr.location && <p className="text-white/50 text-sm font-body">{pr.location}</p>}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 text-center">
        <Reveal>
          <h2 className="font-serif font-light text-4xl md:text-5xl">Your home could be next.</h2>
          <Link data-testid="work-cta" to="/contact" className="mt-8 inline-flex items-center gap-3 bg-gold text-black text-sm font-semibold uppercase tracking-widest px-8 py-4 hover:bg-white transition-colors duration-300">
            Request a Free Quote <ArrowUpRight size={18} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
